<ul class="navbar-nav">
  <ng-container *ngFor="let menuKey of menuKeys; let i = index">
    <li
      class="d-flex align-items-center ps-4 pe-4 navbar-nav__nav-item"
      *ngFor="let item of getMenuItem(menuKey); let i = index"
      (mouseover)="startHover(item.menu_columns)"
      (mouseout)="endHover()"
    >
      <digital-platform-rsx-a
        [url]="item['main_link_url']"
        klass="text-color-white text-decoration-none"
        class="navbar-nav__rich-text-link fill-width"
        [class.navbar-nav__rich-text-link--active]="
          activeMenu === item.menu_columns
        "
        [attr.data-automation-id]="item['main_link_title']"
        >{{ item['main_link_title'] }}</digital-platform-rsx-a
      >
      <span
        class="navbar-nav__chevron-icon"
        [class.navbar-nav__chevron-icon--rotate]="
          activeMenu === item.menu_columns
        "
      ></span>
    </li>
  </ng-container>
</ul>
